import { render, staticRenderFns } from "./ProjetoGestaoLista.vue?vue&type=template&id=019ed3fb&"
import script from "./ProjetoGestaoLista.vue?vue&type=script&lang=js&"
export * from "./ProjetoGestaoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports